import { types, Instance } from 'mobx-state-tree';

export const StatusModel = types.model('StatusModel', {
    id: types.optional(types.string, ''),
    count: types.optional(types.number, 0),
})

export interface IStatusModel extends Instance<typeof StatusModel> {};
